.c-unsupported-browser {
  /* No magic and no Tailwind here, we want this to work in all the old crappy browsers. */

  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  border-bottom: 1px solid #e4e4e7;
  padding: 8em 1em;
  z-index: 10000;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  color: #000;
  background-color: #fff;
}

  .c-unsupported-browser__banner {
    position: relative;
    height: initial;
    width: initial;
    padding: 4em 1em;
    background: #fef9c3;
    border-bottom: 1px solid #fef08a;
  }

  .c-unsupported-browser a {
    text-decoration: underline;
    color: #000;
  }

  .c-unsupported-browser p {
    margin: 0 auto;
    max-width: 975px;
  }

  .c-unsupported-browser table {
    width: auto;
    margin: 0 auto;
    margin-top: 2em;
  }

  .c-unsupported-browser table td {
      padding: 0 1em;
    }

  @media (max-width: 767px) {

  .c-unsupported-browser table td {

    padding-top: 0px;

    padding-bottom: 0px;

    padding-left: 0.75rem;

    padding-right: 0.75rem;

    font-size: 1rem;

    line-height: 1.5rem;
  }

  .c-unsupported-browser table td img {

    height: 2.25rem;

    width: 2.25rem;
  }
}

/*# sourceMappingURL=data:application/json;base64,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 */